// extracted by mini-css-extract-plugin
module.exports = {"comp":"BaseDialog_comp___WvqA"};